module.exports = __webpack_public_path__ + "img/27.f42c0556.jpg";